/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Cash_HintInputs */

const vi_order_settlement_cash_hint = /** @type {(inputs: Order_Settlement_Cash_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để trống = thu đủ số còn nợ`)
};

/**

* @param {Order_Settlement_Cash_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_cash_hint = /** @type {((inputs?: Order_Settlement_Cash_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Cash_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_cash_hint(inputs)
});